// 默认图标配置
export const getDefaultImageConfig = () => {
    return {
    'arrow': require('../assets/pano/arrow.gif'),
    'compass': require('../assets/pano/icon_compass@2x.png'),
    "map-rado": require("../assets/pano/icon_roaming_radar@2x.png"),
    };
  };
  
  // 全局图标配置
  export const imageConfig = {
    ...getDefaultImageConfig(),
  };
  
  // 配置合并
  export function mergeImageConfig(config) {
    Object.assign(imageConfig, getDefaultImageConfig(), config);
  }
  